import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { kpiReport, ltvReport, monthlyLending } from "../../../locales/en";
import { getSalseLead } from "../../../redux/userSalesLeadPersonSlice";
import { getReferralData } from "../../../redux/referraPartnerSlice";
import {
  countries,
  Referral_Type,
  allStatesData,
  timePeriods,
  allTimePeriods
} from "../../../utils/data/data";
import styles from "./../../../assets/scss/custom.module.scss";
import ".././reportStyle.scss";
import {
  MONTH,
  QUARTER,
  YEAR,
  WEEK
} from "../../../utils/constants/appConstants";
import {
  getAllViewType,
  getReferral,
  getYears_periods
} from "../../../utils/getDropdownOptions";

const KpiReportFilter = ({ values, setValues }) => {
  const dispatch = useDispatch();

  const { userSlaesLead } = useSelector((state) => state.userSalseLeadPerson);

  useEffect(() => {
    const getSalseLeadData = async () => {
      await dispatch(getSalseLead()).unwrap();
    };
    getSalseLeadData();
  }, []);

  useEffect(() => {
    const getRefferalsData = async () => {
      await dispatch(getReferralData()).unwrap();
    };
    getRefferalsData();
  }, []);

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValues = { ...values };

    if (type === "checkbox") {
      newValues[name] = checked;
    } else {
      newValues[name] = value;

      if (name === "viewType") {
        const lowerValue = value.toLowerCase();
        newValues[name] = lowerValue;

        if (lowerValue === MONTH.toLowerCase()) {
          newValues.numberOfPeriods = 12;
        } else if (lowerValue === QUARTER.toLowerCase()) {
          newValues.numberOfPeriods = 4;
        } else if (lowerValue === YEAR.toLowerCase()) {
          newValues.numberOfPeriods = "";
        } else if (lowerValue === WEEK.toLowerCase()) {
          newValues.numberOfPeriods = 4;
        }
      }
    }
    setValues(newValues);
  };

  const viewTypeLower = values.viewType?.toLowerCase();

  const renderPeriodOptions = () => {
    if (viewTypeLower === WEEK.toLowerCase()) {
      return allTimePeriods.map((filter) => (
        <option key={filter.id} value={filter.value}>
          {filter.name}
        </option>
      ));
    }
    if (viewTypeLower === YEAR.toLowerCase()) {
      return getYears_periods.map((filter) => (
        <option key={filter.id} value={filter.value}>
          {filter.label}
        </option>
      ));
    }
    return timePeriods.map((filter) => (
      <option key={filter.id} value={filter.value}>
        {filter.name}
      </option>
    ));
  };

  return (
    <div className="row">
      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label htmlFor="view" className={`${styles.selectStatusLabel}`}>
              {kpiReport?.filter.viewTye}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="viewType"
              className={`${styles.selectShowStatus} pe-5`}
              value={values.viewType}
              onChange={onInputChange}
            >
              {getAllViewType().map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter.period}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="numberOfPeriods"
              className={`${styles.selectShowStatus}`}
              value={values.numberOfPeriods}
              onChange={onInputChange}
            >
              {renderPeriodOptions()}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter?.selectCountry}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="country"
              className={`${styles.selectShowStatus}`}
              value={values.country}
              onChange={onInputChange}
            >
              {countries.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter?.selectState}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="state"
              className={`${styles.selectShowStatus}`}
              onChange={onInputChange}
            >
              {allStatesData.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center`}
            >
              {kpiReport?.filter.referral}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="leadSource"
              className={`${styles.selectShowStatus}`}
              value={values.leadSource}
              onChange={onInputChange}
            >
              {getReferral().map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter.referralType}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="referrerType"
              className={`${styles.selectShowStatus}`}
              value={values.referrerType}
              onChange={onInputChange}
            >
              {Referral_Type.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex align-items-center mb-1 mt-1">
        <div className="col-12 d-flex">
          <div className="col-5 d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {ltvReport?.filter.salesLead}
            </label>
          </div>
          <div className="col-7 d-flex">
            <select
              name="salesLead"
              className={`${styles.selectShowStatus}`}
              value={values.salesLead}
              onChange={onInputChange}
            >
              <option value="">{monthlyLending?.filter?.all}</option>
              {userSlaesLead.map((filter) => (
                <option key={filter.id} value={filter.name}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-4 d-flex flter_datepicker mb-1 mt-1 ">
        <div className="col-12 d-flex">
          <div className="col-5">
            <label
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {kpiReport?.filter.withPercent}
            </label>
          </div>
          <div className="col-7 d-flex">
            <input
              type="checkbox"
              name="withPercentage"
              className={`${styles.percentCheckBox}`}
              checked={values.withPercentage || false}
              onChange={onInputChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
KpiReportFilter.propTypes = {
  values: PropTypes.object,
  onInputChange: PropTypes.func,
  setValues: PropTypes.func
};

export default KpiReportFilter;
